import {IProcessFlowMappedVariable} from '~/interfaces/processFlowInterfaces'
import ProcessFlowMappedVariable from '~/models/processFlows/steps/processFlowMappedVariable'
import {ProcessFlowMappedVariableClasses} from '~/models/processFlows/processFlowMappedVariableDefinition'
import ProcessFlowVariableDefinition from '~/models/processFlows/processFlowVariableDefinition'
import IRepo from '~/interfaces/repo'
import Repo from '~/state/modules/repo'

export default class IterationStepMappedVariable extends ProcessFlowMappedVariable implements IProcessFlowMappedVariable {

  get className(): ProcessFlowMappedVariableClasses {
    return 'IterationStepMappedVariable'
  }

  afterPlace = {
    source_variable_path() {
      if (this.destinationVariable && this.source_variable_path?.lastNode) {
        if (!ProcessFlowVariableDefinition.matchesNodeShape(this.destinationVariable, this.source_variable_path?.lastNode)) {
          this.destination_variable_client_id = null
        }
      }
    },
  }

  // ******************** RELATIONS AND REPOS ******************** //
  static repo: IRepo<IterationStepMappedVariable> = new Repo<IterationStepMappedVariable>('processFlowMappedVariables', IterationStepMappedVariable, {});
  repo: IRepo<this>;

  addToRepo(): void {
    IterationStepMappedVariable.repo.add(this)
  }
  // ******************** RELATIONS AND REPOS END ******************** //
}